import React, { useState, useRef, useEffect } from "react";
import Styles from "../../../assets/css/Blogs/RealLifeGadgets/RechargeableSpotlight.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const RechargeableSpotlight = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const RechargeableSpotlight = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/RealLifeGadgets/RechargeableSpotlight/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./44.avif"),
    ProductImages("./45.avif"),
    ProductImages("./46.avif"),
    ProductImages("./50.avif"),
    ProductImages("./52.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[4]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (RechargeableSpotlight.current) {
        const { width, height } =
          RechargeableSpotlight.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Rechargeable Spotlight for Jungle Adventures & More 🌿</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover why rechargeable spotlights are essential for jungle adventures! Explore their long-range lighting, portability, and durability for your next trip."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Rechargeable Spotlights, Jungle Adventures, Outdoor Lighting, Portable Spotlights, Camping Gear, Emergency Lights, LED Spotlights"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Rechargeable Spotlight for Jungle Adventuresm & More 🌿"
        />
        <meta
          property="og:description"
          content="Discover why rechargeable spotlights are essential for jungle adventures! Explore their long-range lighting, portability, and durability for your next trip."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/reallifegadgets/rechargeablespotlight"
        />
        {/* <meta
          property="og:image"
          content="/images/RechargeableSpotlight/52.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Rechargeable Spotlight for Jungle Adventures & More 🌿"
        />
        <meta
          name="twitter:description"
          content="Discover why rechargeable spotlights are essential for jungle adventures! Explore their long-range lighting, portability, and durability for your next trip."
        />
        {/* <meta
          name="twitter:image"
          content="/images/RechargeableSpotlight/52.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/reallifegadgets/rechargeablespotlight"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div
        ref={RechargeableSpotlight}
        className={Styles.RechargeableSpotlightContainer}
      >
        <section className={Styles.RechargeableSpotlightSection1}>
          <div className={Styles.RechargeableSpotlightSection1Text1Container}>
            {/* <h1>Powerful Compact Spotlight for Every Adventure 🌟</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[4]}`}
            alt="Rechargeable Spotlight"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.RechargeableSpotlightSection1Text2Container}>
            <h1>| Rechargeable Spotlight |</h1>
            <h1>Why Rechargeable Spotlights Are a Game-Changer 🌟</h1>
            <p>
              Spotlights are essential for anyone who needs powerful, reliable
              lighting on the go. Whether you're camping, hiking, or working
              late, their long-range and adjustable focus help you light up dark
              paths or narrow areas with ease. Compact and lightweight, these
              spotlights deliver impressive brightness without the bulk, making
              them perfect for any task. With durable design and long-lasting
              batteries, they’re built to withstand tough conditions and provide
              hours of use.
            </p>
          </div>
          <div className={Styles.RechargeableSpotlightSection1Img2Container}>
            <img
              src={`${ProductImagesArray[0]}`}
              alt="Rechargeable Spotlight"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Rechargeable Spotlight"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.RechargeableSpotlightSection1Text3Container}>
            <h1>
              Why Spotlights Are a Must-Have for Every Adventure and Task 🔦
            </h1>
            <p>
              <span style={{ color: "black" }}>
                ✅ Illuminate the Darkest Paths{" "}
              </span>{" "}
              One of the standout features of modern spotlights is their
              long-range lighting capabilities. Whether you're out camping,
              hiking, or navigating your boat, spotlights provide a beam that
              can reach hundreds of meters—ensuring you can light up the darkest
              of paths or scan large areas with ease. This makes them invaluable
              for both recreational and safety purposes.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Lightweight Yet Powerful 💡{" "}
              </span>{" "}
              Gone are the days of bulky, hard-to-carry lights. Today’s
              spotlights, such as the compact rechargeable models, offer high
              brightness—often exceeding 1,000 lumens—while remaining
              lightweight and portable. You can easily carry them on your trips
              without worrying about added weight or discomfort, ensuring your
              hands are free for other tasks while still having reliable
              lighting at your fingertips.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Versatile Lighting for Every Situation 🌍{""}
              </span>{" "}
              Spotlights are not just for outdoor use. They are incredibly
              versatile, designed to meet a wide range of needs. From repairing
              cars in the dark to lighting up your backyard for a late-night
              BBQ, spotlights can handle it all. With adjustable focus settings
              and multiple lighting modes, you can tailor your spotlight’s beam
              to suit any situation, whether you need a wide floodlight or a
              focused spotlight for pinpoint precision.
            </p>
            <p>
              <span style={{ color: "black" }}>Hands-Free Convenience 🚶‍♂️ </span>{" "}
              Spotlights that come with features like remote control or
              hands-free stands are game-changers. Whether you’re working in a
              tight spot or need to keep the light fixed on a particular area,
              these tools allow you to adjust your spotlight’s position or turn
              it on/off without hassle. You don’t even need to bend over or
              juggle between tasks—your spotlight can work for you while you
              focus on what matters.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Built to Endure Tough Conditions 🛠️{" "}
              </span>{" "}
              The best spotlights are designed to withstand tough conditions,
              ensuring that they work when you need them most. Whether it’s
              water-resistant, drop-resistant, or equipped with high-quality
              batteries, a good spotlight is a reliable companion in any
              environment. Whether you're navigating a storm or working in harsh
              outdoor conditions, your spotlight will continue to shine
              brightly.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Perfect for Long-Lasting Use 🔋{" "}
              </span>{" "}
              The modern spotlight’s extended battery life is a key feature that
              makes it a game-changer. With a fully charged spotlight, you can
              count on hours of illumination, which is perfect for long trips or
              working on projects that require consistent lighting. No need to
              worry about the battery running out at the wrong moment.
            </p>
          </div>
          <div className={Styles.RechargeableSpotlightSection1Img3Container}>
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Rechargeable Spotlight"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Rechargeable Spotlight"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.RechargeableSpotlightSection1Text4Container}>
            <h1>Why Spotlights Are More Convenient Than Other Lights 🔦</h1>
            <p>
              Spotlights offer unmatched convenience compared to traditional
              lights. Unlike basic flashlights, spotlights provide a powerful
              beam that can reach farther distances, illuminating large areas
              with ease—perfect for outdoor adventures, work tasks, or
              emergencies. They’re also lightweight, rechargeable, and designed
              to last for hours, so you don’t need to worry about constantly
              changing batteries. With features like adjustable focus and
              hands-free operation, spotlights make it easier to focus the light
              exactly where you need it without hassle. They are simply a more
              reliable and practical solution for any situation. 🌟
            </p>
          </div>
          <div className={Styles.RechargeableSpotlightSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/42VScGM"
            target="_blank"
            rel="noopener noreferrer"
            className={
              Styles.RechargeableSpotlightSection1BtnAmazonAncherContainer
            }
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.RechargeableSpotlightSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div
            className={Styles.RechargeableSpotlightSection1DesclaimerContainer}
          >
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #RechargeableSpotlight #LEDSpotlight #OutdoorGear #BrightLight
              #CampingEssentials #EmergencyLight #PortableSpotlight #HikingGear
              #WaterResistantLight #FindTheBest
            </p>
            <h1>Keywords</h1>
            <p>
              Best rechargeable spotlight for 2025 outdoor adventures High-lumen
              spotlight for camping, hiking, and emergencies Long-lasting
              battery-powered spotlight with USB charging Water-resistant
              handheld spotlight for all-weather use Durable and lightweight
              design for easy portability Multi-mode LED spotlight with
              adjustable brightness Powerful beam distance for nighttime
              visibility and safety
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default RechargeableSpotlight;
